export default __webpack_public_path__ + "static/media/lightPaste.b8f31944.svg";